var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CadastroViagemDialog',{attrs:{"value":_vm.value,"viagem":_vm.viagem},on:{"input":function($event){return _vm.$emit('input', $event)},"saved":function($event){return _vm.$emit('saved', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }